/**
 * @typedef {number} ParticipantState
 */

export const PARTICIPANT_STATE__IN_PROGRESS = 1;
export const PARTICIPANT_STATE__FINISHED    = 2;

/**
* @param {ParticipantState} state
* @returns {string}
*/
export function getParticipantStateName(state) {
  switch(state) {
    case PARTICIPANT_STATE__IN_PROGRESS: return 'участвует';
    case PARTICIPANT_STATE__FINISHED:    return 'вышел';
  }

  return `Unknown state ${state}.`;
}

/**
 * @param {ParticipantState} state
 * @returns {Object}
 */
export function getParticipantStateClass(state) {
  return {
    rushRaceParticipantStateInProgress: (state === PARTICIPANT_STATE__IN_PROGRESS),
  };
}
